import React from 'react'
import SEO from '~/components/seo'

const GetTestedPage = () => (
  <>
    <SEO title="Get Tested" keywords={[`get tested`]} />
    <h1>Get Tested</h1>
  </>
)

export default GetTestedPage
